export default defineNuxtPlugin(() => {
  const baseStore = useBaseStore()
  const userStore = useUserStore()

  // Initialize Plausible function
  window.plausible = window.plausible || function () {
    (window.plausible.q = window.plausible.q || []).push(arguments)
  }

  // Crisp: queue chat:hide before l.js so the launcher rarely flashes; session updates re-hide after.
  window.$crisp = []
  window.CRISP_WEBSITE_ID = '85a52bd0-9acf-4424-87a5-85da440b691b'
  window.$crisp.push(['do', 'chat:hide'])

  const initializeCrispUser = () => {
    nextTick(() => {
      if (!window.$crisp)
        return

      if (userStore.user && userStore.user.crisp_token) {
        // User is logged in with Crisp token
        window.CRISP_TOKEN_ID = userStore.user.hash
        // window.$crisp.push(['do', 'session:reset'])
        window.$crisp.push(['set', 'user:email', [userStore.user.email, userStore.user.crisp_token]])
        const sessionData = [
          ['app', baseStore.platform],
          ['version', baseStore.version],
          ['extra', userStore.user.extra],
          ['extra_active_trial', userStore.user.extra_active_trial],
          ['trial_status', userStore.user.trial_status],
          ['trial_ends_at', (userStore.user.trial_ends_at == null ? '-' : userStore.user.trial_ends_at)],
          ['session_sent', 1],
        ]
        window.$crisp.push(['set', 'session:data', [sessionData]])
      }
      else {
        // User is not logged in or no Crisp token
        const sessionData = [
          ['app', baseStore.platform],
          ['version', baseStore.version],
        ]
        console.log('Crisp session data:', sessionData)
        window.$crisp.push(['do', 'session:reset'])
        window.$crisp.push(['set', 'session:data', [sessionData]])
      }
      if (!baseStore.crispChatOpen)
        window.$crisp.push(['do', 'chat:hide'])
    })
  }

  // Watch for user changes and update Crisp accordingly
  watch(() => userStore.user, () => {
    if (window.$crisp) {
      initializeCrispUser()
    }
  }, { immediate: true })

  // Wait for platform detection to complete
  nextTick(() => {
    // Plausible is essential first-party analytics and always loads independently of optional consent.
    if (!document.getElementById('glouton-plausible')) {
      const plausibleScript = document.createElement('script')
      plausibleScript.id = 'glouton-plausible'
      plausibleScript.defer = true
      plausibleScript.setAttribute('data-domain', 'glouton.app')
      plausibleScript.setAttribute('event-origin', baseStore.platform)
      plausibleScript.src = 'https://s.glouton.app/js/script.local.pageview-props.js'
      document.head.appendChild(plausibleScript)
    }

    // Create and load the Crisp chat script
    const crispScript = document.createElement('script')
    crispScript.type = 'text/javascript'
    crispScript.async = true
    crispScript.src = 'https://client.crisp.chat/l.js'

    // Add scripts to head
    document.head.appendChild(crispScript)

    crispScript.onload = () => {
      baseStore.registerCrispChatListeners()
      if (!baseStore.crispChatOpen)
        window.$crisp.push(['do', 'chat:hide'])
      initializeCrispUser()
    }
  })
})
